import { LOAN_APIS } from "./loan-api-factory";
import axios from 'axios'

// Use regular axios instance like existing APIs
const loanApi = axios;

// QR Code
export const getQrCode = (doctorId, callback, error) => {
    const headerConfig = {
        headers: {
            'Accept': 'application/json'
        }
    };
    
    loanApi.get(LOAN_APIS.GET_QR_CODE(doctorId), headerConfig)
        .then(res => {
            if (res.data.status === 200 && res.data.data) {
                callback({
                    success: true,
                    qrCodeUrl: res.data.data
                });
            } else {
                error(new Error(res.data.message || 'Failed to get QR code'));
            }
        })
        .catch(e => {
            error(e);
        });
};

// Activities Log
export const getActivitiesLog = (userId, callback, error) => {
    const headerConfig = {
        headers: {
            'Accept': 'application/json'
        }
    };
    
    loanApi.get(LOAN_APIS.GET_ACTIVITIES_LOG(userId), headerConfig)
        .then(res => {
            if (res.data.status === 200 && Array.isArray(res.data.data)) {
                callback(res.data.data);
            } else {
                error(new Error(res.data.message || 'Failed to get activities log'));
            }
        })
        .catch(e => {
            error(e);
        });
};

// User Loan Status
export const getUserLoanStatus = (loanId, callback, error) => {
    const headerConfig = {
        headers: {
            'Accept': 'application/json'
        }
    };
    
    loanApi.get(LOAN_APIS.GET_USER_LOAN_STATUS(loanId), headerConfig)
        .then(res => {
            if (res.data.status === 200 && Array.isArray(res.data.data)) {
                callback(res.data.data);
            } else {
                error(new Error(res.data.message || 'Failed to fetch user loan status'));
            }
        })
        .catch(e => {
            error(e);
        });
};

// Assigned Product
export const getAssignedProduct = (userId, callback, error) => {
    const headerConfig = {
        headers: {
            'Accept': 'application/json'
        }
    };
    
    loanApi.get(LOAN_APIS.GET_ASSIGNED_PRODUCT(userId), headerConfig)
        .then(res => {
            if (res.data.status === 200 && res.data.data) {
                callback(res.data.data);
            } else {
                callback(null); // No assigned product found
            }
        })
        .catch(e => {
            if (e.response?.status === 404) {
                callback(null); // No assigned product found
            } else {
                error(e);
            }
        });
};

// Bureau Decision
export const getBureauDecision = (loanId, callback, error) => {
    const headerConfig = {
        headers: {
            'Accept': 'application/json'
        }
    };
    
    loanApi.get(LOAN_APIS.GET_BUREAU_DECISION(loanId), headerConfig)
        .then(res => {
            if (res.data.status === 200 && res.data.data?.success && res.data.data.data?.emiPlanList) {
                callback(res.data.data.data.emiPlanList);
            } else {
                callback([]);
            }
        })
        .catch(e => {
            callback([]);
        });
};

// Bureau Decision Data
export const getBureauDecisionData = (loanId, callback, error) => {
    const headerConfig = {
        headers: {
            'Accept': 'application/json'
        }
    };
    
    loanApi.get(LOAN_APIS.GET_BUREAU_DECISION(loanId), headerConfig)
        .then(res => {
            if (res.data.status === 200 && res.data.data?.success && res.data.data.data) {
                callback(res.data.data.data);
            } else {
                callback(null);
            }
        })
        .catch(e => {
            callback(null);
        });
};

// Matching EMI Plans
export const getMatchingEmiPlansFromAPI = (userId, loanId, callback, error) => {
    const headerConfig = {
        headers: {
            'Accept': 'application/json'
        }
    };
    
    loanApi.get(LOAN_APIS.GET_MATCHING_EMI_PLANS(userId, loanId), headerConfig)
        .then(res => {
            if (res.data.status === 200 && res.data.data) {
                callback(res.data.data);
            } else {
                error(new Error(res.data.message || 'Failed to get matching EMI plans'));
            }
        })
        .catch(e => {
            error(e);
        });
};

// Legacy method for backward compatibility
export const getMatchingEmiPlans = (userId, loanId, callback, error) => {
    // First try the new API endpoint
    getMatchingEmiPlansFromAPI(userId, loanId, callback, (apiError) => {
        console.error('New API failed, falling back to legacy method:', apiError);
        
        // Fallback to legacy method
        getAssignedProduct(userId, (assignedProduct) => {
            const assignedProductFailed = !assignedProduct;
            
            getBureauDecisionData(loanId, (decisionData) => {
                if (!decisionData) {
                    callback({ 
                        plans: [], 
                        hasMatchingProduct: false, 
                        isApproved: false, 
                        assignedProductFailed 
                    });
                    return;
                }

                const emiPlans = decisionData.emiPlanList;
                const isApproved = decisionData.finalDecision.toLowerCase() === 'approved';

                if (isApproved && emiPlans.length > 0) {
                    if (assignedProduct) {
                        // Filter EMI plans that match the productId
                        const matchingPlans = emiPlans.filter(plan => 
                            plan.productDetailsDO.productId === assignedProduct.productId
                        );
                        
                        if (matchingPlans.length > 0) {
                            callback({ 
                                plans: matchingPlans, 
                                hasMatchingProduct: true,
                                isApproved: true,
                                assignedProductFailed: false
                            });
                        } else {
                            callback({ 
                                plans: [], 
                                hasMatchingProduct: false, 
                                isApproved: true, 
                                assignedProductFailed: false 
                            });
                        }
                    } else {
                        callback({ 
                            plans: emiPlans, 
                            hasMatchingProduct: true,
                            isApproved: true,
                            assignedProductFailed: true
                        });
                    }
                } else {
                    callback({ 
                        plans: [], 
                        hasMatchingProduct: false, 
                        isApproved: false, 
                        assignedProductFailed 
                    });
                }
            }, error);
        }, error);
    });
};

// Disburse Detail Report
export const getDisburseDetailForReport = (userId, callback, error) => {
    const headerConfig = {
        headers: {
            'Accept': 'application/pdf'
        },
        responseType: 'blob'
    };
    
    loanApi.get(LOAN_APIS.GET_DISBURSE_DETAIL_FOR_REPORT(userId), headerConfig)
        .then(res => {
            // Create blob URL for download
            const blob = new Blob([res.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            
            // Create temporary download link
            const link = document.createElement('a');
            link.href = url;
            link.download = `disbursal-report-${userId}.pdf`;
            document.body.appendChild(link);
            link.click();
            
            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            callback({ success: true });
        })
        .catch(e => {
            error(e);
        });
};

// Upload Prescription
export const uploadPrescription = (file, userId, callback, error) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userId', userId);
    formData.append('type', 'img');
    formData.append('fileName', 'treatmentProof');

    const headerConfig = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json'
        }
    };
    
    loanApi.post(LOAN_APIS.UPLOAD_DOCUMENTS(), formData, headerConfig)
        .then(res => {
            if (res.data.status === 200 || res.data.status === '200' || res.data.message === 'success') {
                callback({
                    success: true,
                    fileUrl: res.data.data,
                    message: 'Document uploaded successfully'
                });
            } else {
                error(new Error(res.data.message || 'Failed to upload document'));
            }
        })
        .catch(e => {
            error(e);
        });
};

// Upload Treatment Invoice
export const uploadTreatmentInvoice = (file, userId, loanId, callback, error) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('userId', userId);
    formData.append('loanId', loanId);
    formData.append('type', 'img');
    formData.append('fileName', 'treatmentInvoice');

    const headerConfig = {
        headers: {
            'Content-Type': 'multipart/form-data',
            'Accept': 'application/json'
        }
    };
    
    loanApi.post(LOAN_APIS.UPLOAD_DOCUMENTS(), formData, headerConfig)
        .then(res => {
            if (res.data.status === 200 || res.data.status === '200' || res.data.message === 'success') {
                callback({
                    success: true,
                    fileUrl: res.data.data,
                    message: 'success'
                });
            } else {
                error(new Error(res.data.message || 'Failed to upload treatment invoice'));
            }
        })
        .catch(e => {
            error(e);
        });
};

// Loan Transactions
export const getLoanTransactions = (doctorId, params = {}, callback, error) => {
    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        timeout: 30000
    };
    
    const url = LOAN_APIS.GET_LOAN_TRANSACTIONS(doctorId, params);
    console.log('Making API call to:', url);
    console.log('With params:', params);
    console.log('Status filter being sent to API:', params.loanStatus);
    
    loanApi.get(url, headerConfig)
        .then(res => {
            console.log('API Response:', res.data);
            
            // Check if the response contains an error
            if (res.data.errorCode || res.data.cause) {
                console.error('API returned error:', res.data);
                error(new Error(res.data.cause || res.data.message || 'Failed to fetch loan transactions'));
                return;
            }
            
            // Check if we have valid data
            if (res.data.status === 200 && Array.isArray(res.data.data)) {
                callback(res.data.data);
            } else if (Array.isArray(res.data)) {
                // Sometimes the API might return the array directly
                callback(res.data);
            } else {
                console.error('API returned non-200 status or invalid data:', res.data);
                error(new Error(res.data.message || 'Failed to fetch loan transactions'));
            }
        })
        .catch(e => {
            console.error('API call failed:', e);
            console.error('Error response:', e.response);
            error(e);
        });
};

// All Child Clinics
export const getAllChildClinics = (doctorId, callback, error) => {
    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        timeout: 30000
    };
    
    loanApi.get(LOAN_APIS.GET_ALL_CHILD_CLINICS(doctorId), headerConfig)
        .then(res => {
            console.log('Child clinics API response:', res.data);
            
            // Check if API returned status 200 and has data
            if (res.data.status === 200 && Array.isArray(res.data.data) && res.data.data.length > 0) {
                callback(res.data.data);
            } else if (res.data.status === 200 && Array.isArray(res.data.data) && res.data.data.length === 0) {
                // API returned 200 but no clinics data - don't show filter
                error(new Error('No clinics available for this doctor'));
            } else {
                error(new Error(res.data.message || 'Failed to fetch child clinics'));
            }
        })
        .catch(e => {
            console.error('Child clinics API error:', e);
            error(e);
        });
};

// Loan Count and Amount
export const getLoanCountAndAmountForDoctor = (doctorId, clinicName = '', callback, error) => {
    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        timeout: 30000
    };
    
    loanApi.get(LOAN_APIS.GET_LOAN_COUNT_AND_AMOUNT(doctorId, clinicName), headerConfig)
        .then(res => {
            if (res.data.status === 200 && res.data.data) {
                callback(res.data.data);
            } else {
                error(new Error(res.data.message || 'Failed to fetch loan count and amount statistics'));
            }
        })
        .catch(e => {
            error(e);
        });
};

// Loan Details by User ID
export const getLoanDetailsByUserId = (userId, callback, error) => {
    const headerConfig = {
        headers: {
            'Accept': 'application/json'
        }
    };
    
    loanApi.get(LOAN_APIS.GET_LOAN_DETAILS_BY_USER_ID(userId), headerConfig)
        .then(res => {
            if (res.data.status === 200 && res.data.data) {
                callback(res.data.data);
            } else {
                callback(null);
            }
        })
        .catch(e => {
            if (e.response?.status === 404) {
                callback(null);
            } else {
                error(e);
            }
        });
};

// Unified timeline function
export const getUserLoanTimeline = (loanId, userId, callback, error) => {
    // First try getUserLoanStatus API
    getUserLoanStatus(loanId, (userLoanStatus) => {
        if (userLoanStatus && userLoanStatus.length > 0) {
            // Convert to timeline format
            const timeline = userLoanStatus.map(item => ({
                status: item.userStatus,
                addedOn: item.addedOn,
                loanId: item.loanId,
                activity: item.userStatus
            }));
            callback(timeline);
        } else {
            // Fallback to activitiesLog API
            if (!userId) {
                error(new Error('userId is required when falling back to activitiesLog'));
                return;
            }
            
            getActivitiesLog(userId, (activitiesLog) => {
                if (activitiesLog && activitiesLog.length > 0) {
                    // Filter activities related to the specific loan
                    const filteredActivities = activitiesLog.filter(activity => 
                        !loanId || activity.loanId === loanId || !activity.loanId
                    );
                    
                    // Convert to timeline format
                    const timeline = filteredActivities.map(activity => {
                        const formatTimestamp = (timestamp) => {
                            try {
                                const date = new Date(timestamp);
                                return date.toLocaleString('en-GB', {
                                    hour: 'numeric',
                                    minute: '2-digit',
                                    hour12: false,
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric'
                                });
                            } catch (e) {
                                return 'Invalid Date';
                            }
                        };

                        return {
                            status: activity.activity,
                            addedOn: formatTimestamp(activity.addedOn),
                            loanId: activity.loanId || undefined,
                            activity: activity.activity,
                            id: activity.id,
                            userId: activity.userId,
                            addedBy: activity.addedBy,
                            updatedOn: activity.updatedOn,
                            comments: activity.comments
                        };
                    });
                    callback(timeline);
                } else {
                    callback([]);
                }
            }, error);
        }
    }, (statusError) => {
        // If getUserLoanStatus fails, try activitiesLog
        if (!userId) {
            error(new Error('userId is required when falling back to activitiesLog'));
            return;
        }
        
        getActivitiesLog(userId, (activitiesLog) => {
            if (activitiesLog && activitiesLog.length > 0) {
                const filteredActivities = activitiesLog.filter(activity => 
                    !loanId || activity.loanId === loanId || !activity.loanId
                );
                
                const timeline = filteredActivities.map(activity => {
                    const formatTimestamp = (timestamp) => {
                        try {
                            const date = new Date(timestamp);
                            return date.toLocaleString('en-GB', {
                                hour: 'numeric',
                                minute: '2-digit',
                                hour12: false,
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                            });
                        } catch (e) {
                            return 'Invalid Date';
                        }
                    };

                    return {
                        status: activity.activity,
                        addedOn: formatTimestamp(activity.addedOn),
                        loanId: activity.loanId || undefined,
                        activity: activity.activity,
                        id: activity.id,
                        userId: activity.userId,
                        addedBy: activity.addedBy,
                        updatedOn: activity.updatedOn,
                        comments: activity.comments
                    };
                });
                callback(timeline);
            } else {
                callback([]);
            }
        }, error);
    });
};

// Helper function to format loan transaction
export const formatLoanTransaction = (loan) => {
    const formatDate = (dateStr) => {
        try {
            const date = new Date(dateStr);
            return date.toLocaleString('en-GB', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true,
            });
        } catch (e) {
            return dateStr;
        }
    };

    // Helper function to check if loan status should be considered as approved
    const isLoanApproved = (status) => {
        if (!status) {
            return false;
        }
        
        const approvedStatuses = [
            'Approved',
            'Loan Approved',
            'EMI plans elgibility check',
            'EMI plan selected',
            'Lender flow initiated',
            'KYC required',
            'KYC in progress',
           
        
            'KYC complete',
            'Agreement signing initiated',
            'Agreement generated',
      
            'Agreement signed',
            'EMI auto pay setup in progress',
            
           
            'EMI auto-pay setup complete',
            'Verification initiated for disbursal',
            'Verification completed for disbursal',
            'Disbursal initiated',
       
        
          
        ];
        
        const normalizedStatus = status.trim().toLowerCase();
        const normalizedApprovedStatuses = approvedStatuses.map(s => s.trim().toLowerCase());
        
        return normalizedApprovedStatuses.includes(normalizedStatus);
    };

    const isInvoiceReceivedValue = (value) => {
        if (value === true || value === 1) return true;
        const text = String(value ?? '').trim().toLowerCase();
        if (!text || text === 'required' || text === 'pending' || text === 'false' || text === '0') {
            return false;
        }
        return text === 'received' || text === 'uploaded' || text === 'complete' || text === 'true';
    };

    const finalStatus = String(loan.loanFinalStatus || '').trim();
    let loanStatus = 'Unknown';
    if (finalStatus.toLowerCase() === 'rejected') {
        loanStatus = loan.loanFinalStatus;
    } else if (loan.status && loan.status.loan && loan.status.loan.loanStatus) {
        loanStatus = loan.status.loan.loanStatus;
    } else if (loan.status && typeof loan.status === 'string') {
        loanStatus = loan.status;
    }
    
    const isApproved = isLoanApproved(loanStatus);

    const postApprovalChecklist = {
        kyc: Boolean(loan.kyc),
        faceVerification: Boolean(loan.faceVerification),
        agreementSigned: Boolean(loan.agreementSigned),
        emiAutoPay: Boolean(loan.emiAutoPay),
        verificationCall: Boolean(loan.verificationCall),
        nameMatchVerification: Boolean(loan.nameMatchVerification),
        treatmentBill: isInvoiceReceivedValue(loan.treatmentInvoice ?? loan.treatmentBill)
    };

    return {
        id: loan.loanId,
        loanId: loan.loanId,
        userId: loan.userId,
        amount: loan.loanAmount != null ? Number(loan.loanAmount).toLocaleString('en-IN') : '0',
        loanAmountRaw: loan.loanAmount,
        name: loan.firstName || loan.patientName || 'Unknown',
        treatment: loan.loanReason || '',
        appliedAt: formatDate(loan.loanApplyDate),
        appliedDate: (() => {
            try {
                const date = new Date(loan.loanApplyDate);
                if (Number.isNaN(date.getTime())) return '';
                return date.toLocaleDateString('en-GB', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                });
            } catch (e) {
                return '';
            }
        })(),
        status: loanStatus,
        approved: isApproved,
        utr: loan.utrNo || loan.utr || loan.utrNumber || undefined,
        disbursedAt: loan.disburseDate ? formatDate(loan.disburseDate) : undefined,
        lender: loan.lenderName || '',
        maxLimit: loan.treatmentAmount && loan.loanAmount && loan.treatmentAmount > loan.loanAmount ? Number(loan.treatmentAmount).toLocaleString('en-IN') : undefined,
        onboardingUrl: loan.onboardingUrl || undefined,
        shareableLink: loan.onboardingUrl || undefined,
        patientPhoneNo: loan.mobileNumber ? parseInt(loan.mobileNumber) : undefined,
        mobileNumber: loan.mobileNumber || undefined,
        applicationId: loan.applicationId || undefined,
        clinicName: loan.clinicName || undefined,
        doctorName: loan.doctorName || undefined,
        employmentType: loan.employmentType || undefined,
        commentType: loan.commentType || undefined,
        commentText: loan.commentText || undefined,
        treatmentInvoice: loan.treatmentInvoice ?? loan.treatmentBill,
        lenderName: loan.lenderName || loan.lender || '',
        postApprovalChecklist
    };
};

// Function to get detailed transaction information
export const getTransactionDetails = (loanId, callback, error) => {
    const headerConfig = {
        headers: {},
    };
    
    const doctorId = localStorage.getItem("doctorId");
    
    axios.get(LOAN_APIS.GET_TRANSACTION_DETAILS(loanId, doctorId), headerConfig)
        .then(res => {
            callback(res.data);
        })
        .catch(e => {
            error(e);
        });
};

// Upload Invoice
export const uploadInvoice = (file, loanId, billingDate, invoiceNumber, callback, error) => {
    console.log('Pre-Disbursal Step API: Uploading invoice file:', file);
    console.log('Pre-Disbursal Step API: File type:', file instanceof File ? 'File' : 'Blob');
    console.log('Pre-Disbursal Step API: File size:', file.size, 'bytes');
    console.log('Pre-Disbursal Step API: File name:', file instanceof File ? file.name : 'N/A');
    console.log('Pre-Disbursal Step API: File MIME type:', file.type || 'N/A');
    
    // Validate file
    if (!file) {
        error(new Error('No file provided'));
        return;
    }
    
    if (file.size === 0) {
        error(new Error('File is empty'));
        return;
    }
    
    // Create FormData for file upload
    const formData = new FormData();
    
    // Append file with proper filename (required for FormData to work correctly)
    // If it's a File, use its name, otherwise generate a default name based on MIME type
    let fileName;
    if (file instanceof File) {
        fileName = file.name;
    } else {
        // For Blob, determine extension from MIME type
        const extension = file.type?.includes('pdf') 
            ? 'pdf' 
            : file.type?.includes('jpeg') || file.type?.includes('jpg')
            ? 'jpg'
            : file.type?.includes('png')
            ? 'png'
            : 'pdf'; // default to pdf
        fileName = `invoice-${Date.now()}.${extension}`;
    }
    
    // Append file with filename (third parameter is required for proper FormData serialization)
    formData.append('file', file, fileName);
    formData.append('loanId', loanId);
    formData.append('billingDate', billingDate);
    formData.append('invoiceNumber', invoiceNumber);
    
    // Log FormData contents for debugging
    console.log('Pre-Disbursal Step API: FormData entries:');
    for (const [key, value] of formData.entries()) {
        console.log(`  ${key}:`, value instanceof File ? `File(${value.name}, ${value.size} bytes)` : value);
    }
    
    const headerConfig = {
        headers: {
            'Accept': 'application/json',
            // Don't set Content-Type, let browser set it with boundary for multipart/form-data
        },
        timeout: 60000, // 60 second timeout for file upload
    };
    
    loanApi.post(LOAN_APIS.UPLOAD_INVOICE(), formData, headerConfig)
        .then(res => {
            const { status, data, message } = res.data;

            // Check both numeric and string status since API might return either
            if (status === 200 || status === '200' || message === 'success' || message?.toLowerCase() === 'success') {
                callback({
                    success: true,
                    fileUrl: typeof data === 'string' ? data : undefined,
                    data: typeof data === 'object' ? data : undefined,
                    message: message || 'Invoice uploaded successfully',
                    statusCode: typeof status === 'number' ? status : 200
                });
            } else {
                error(new Error(message || 'Failed to upload invoice'));
            }
        })
        .catch(e => {
            console.error('Pre-Disbursal Step API: Error uploading invoice:', e);
            
            // Handle axios errors
            if (e.response) {
                const { status, data } = e.response;
                
                // Handle specific error status codes
                if (status === 401) {
                    error(new Error('Authentication required. Please login again.'));
                } else if (status === 413) {
                    error(new Error('File is too large. Please upload a smaller file.'));
                } else if (status === 415) {
                    error(new Error('Invalid file type. Please upload an image or PDF file.'));
                } else {
                    error(new Error(data?.message || data?.data || `Failed to upload invoice (Status: ${status})`));
                }
            } else if (e.request) {
                error(new Error('Network error. Please check your internet connection and try again.'));
            } else {
                error(new Error(e.message || 'An unexpected error occurred while uploading invoice'));
            }
        });
};

// Get Treatment Invoice Data
export const getTreatmentInvoiceData = (loanId, callback, error) => {
    console.log('Pre-Disbursal Step API: Getting treatment invoice data for loanId:', loanId);
    
    const headerConfig = {
        headers: {
            'Accept': 'application/json'
        }
    };
    
    loanApi.get(LOAN_APIS.GET_TREATMENT_INVOICE_DATA(loanId), headerConfig)
        .then(res => {
            const { status, data, message } = res.data;

            // Check if the response indicates success (status 200) and data is not an error message
            if (status === 200 && typeof data !== 'string') {
                callback({
                    success: true,
                    data: data,
                    message: message || 'Treatment invoice data retrieved successfully',
                    statusCode: status
                });
            } else {
                // Handle cases where status is not 200 or data is an error message
                error(new Error(typeof data === 'string' ? data : message || 'Failed to retrieve treatment invoice data'));
            }
        })
        .catch(e => {
            console.error('Pre-Disbursal Step API: Error getting treatment invoice data:', e);
            
            // Handle axios errors
            if (e.response) {
                const { status, data } = e.response;
                error(new Error(data?.message || data?.data || 'Failed to retrieve treatment invoice data'));
            } else if (e.request) {
                error(new Error('Network error. Please check your internet connection and try again.'));
            } else {
                error(new Error(e.message || 'An unexpected error occurred while retrieving treatment invoice data'));
            }
        });
};

const normalizeDateParts = (dateString) => {
    if (!dateString) return null;
    const text = String(dateString).trim();
    const slashOrDash = text.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
    if (slashOrDash) {
        return {
            day: slashOrDash[1].padStart(2, '0'),
            month: slashOrDash[2].padStart(2, '0'),
            year: slashOrDash[3],
        };
    }
    const iso = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) {
        return { day: iso[3], month: iso[2], year: iso[1] };
    }
    return null;
};

const toApiDate = (dateString) => {
    const parts = normalizeDateParts(dateString);
    if (!parts) return '';
    return `${parts.day}-${parts.month}-${parts.year}`;
};

const toInputDate = (dateString) => {
    const parts = normalizeDateParts(dateString);
    if (!parts) return '';
    return `${parts.year}-${parts.month}-${parts.day}`;
};

const asLoanApiPromise = (fn, ...args) =>
    new Promise((resolve, reject) => fn(...args, resolve, reject));

export const runOcrTreatmentInvoice = (file, loanId, callback, error) => {
    if (!file || !loanId) {
        error(new Error('Invoice file and loan ID are required'));
        return;
    }

    const form = new FormData();
    form.append('document', file);
    form.append('loan_id', loanId);

    fetch(LOAN_APIS.OCR_TREATMENT_INVOICE(), { method: 'POST', body: form })
        .then(async (res) => {
            if (!res.ok) throw new Error('OCR API failed');
            const data = await res.json();
            if (data?.success && data?.data) {
                callback({
                    success: true,
                    data: {
                        ...data.data,
                        billing_date: toInputDate(data.data.billing_date),
                    },
                });
            } else {
                throw new Error('OCR extraction failed');
            }
        })
        .catch((e) => error(new Error(e.message || 'Failed to scan invoice')));
};

export const verifyTreatmentInvoice = (loanId, callback, error) => {
    fetch(LOAN_APIS.VERIFY_TREATMENT_INVOICE(loanId))
        .then(async (res) => {
            if (!res.ok) throw new Error('Verification API failed');
            const data = await res.json();
            callback({ success: true, data });
        })
        .catch((e) => error(new Error(e.message || 'Failed to verify invoice')));
};

export const saveTreatmentInvoice = (file, loanId, invoiceData, callback, error) => {
    if (!file || !loanId) {
        error(new Error('Invoice file and loan ID are required'));
        return;
    }

    const required = ['customer_name', 'treatment_name', 'invoice_number', 'billing_date', 'total_amount'];
    const missing = required.filter((key) => !invoiceData?.[key]);
    if (missing.length) {
        error(new Error('Please fill all invoice details'));
        return;
    }

    uploadInvoice(
        file,
        loanId,
        toApiDate(invoiceData.billing_date),
        invoiceData.invoice_number,
        () => {
            updateTreatmentInvoiceData(
                {
                    loan_id: loanId,
                    customer_name: invoiceData.customer_name,
                    treatment_name: invoiceData.treatment_name,
                    invoice_number: invoiceData.invoice_number,
                    billing_date: toApiDate(invoiceData.billing_date),
                    total_amount: invoiceData.total_amount,
                },
                (updateRes) => {
                    verifyTreatmentInvoice(
                        loanId,
                        (verifyRes) => {
                            callback({
                                success: true,
                                data: updateRes?.data,
                                verification: verifyRes?.data,
                                message: 'Invoice saved successfully',
                            });
                        },
                        () => {
                            callback({
                                success: true,
                                data: updateRes?.data,
                                message: 'Invoice saved successfully',
                            });
                        }
                    );
                },
                error
            );
        },
        error
    );
};

export const updateTreatmentInvoiceData = (payload, callback, error) => {
    loanApi.post(LOAN_APIS.UPDATE_TREATMENT_INVOICE_DATA(), payload, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        timeout: 30000,
    })
        .then((res) => {
            const status = res.data?.status;
            if (status === 200 || status === '200' || res.data?.message === 'success' || res.data) {
                callback({
                    success: true,
                    data: res.data?.data ?? res.data,
                    message: res.data?.message || 'Invoice data updated',
                });
            } else {
                error(new Error(res.data?.message || 'Failed to update invoice data'));
            }
        })
        .catch((e) => {
            error(new Error(e.response?.data?.message || e.message || 'Failed to update invoice data'));
        });
};

export const getFinalLenderDecisionDetails = (loanId, callback, error) => {
    loanApi.get(LOAN_APIS.GET_FINAL_LENDER_DECISION(loanId), {
        headers: { Accept: 'application/json' },
        timeout: 30000,
    })
        .then((res) => {
            callback({
                success: true,
                data: res.data?.data ?? res.data,
                message: res.data?.message || 'Lender decision retrieved',
            });
        })
        .catch((e) => {
            error(new Error(e.response?.data?.message || e.message || 'Failed to fetch lender decision'));
        });
};

export const scanAndUploadTreatmentInvoice = (file, loanId, _userId, callback, error) => {
    runOcrTreatmentInvoice(
        file,
        loanId,
        (ocrResult) => {
            saveTreatmentInvoice(file, loanId, ocrResult.data, callback, error);
        },
        () => {
            error(new Error('OCR failed. Please enter invoice details manually.'));
        }
    );
};

// Get Interest Enabled Status by Doctor ID
export const getInterestEnabledByDoctorId = (doctorId, callback, error) => {
    console.log('Fetching interest enabled status for doctor ID:', doctorId);
    
    const headerConfig = {
        headers: {
            'Accept': 'application/json'
        }
    };
    
    loanApi.get(LOAN_APIS.GET_INTEREST_ENABLED_BY_DOCTOR_ID(doctorId), headerConfig)
        .then(res => {
            console.log('Interest enabled by doctor ID response:', res.data);
            
            // Check if the response is successful
            if (res.data.status === 200) {
                callback({
                    success: true,
                    data: res.data.data,
                    message: res.data.message || 'Interest enabled status retrieved successfully'
                });
            } else {
                // Handle non-200 status responses
                error(new Error(res.data.message || 'Failed to retrieve interest enabled status'));
            }
        })
        .catch(e => {
            console.error('Error getting interest enabled by doctor ID:', e);
            
            // Handle axios errors
            if (e.code === 'ECONNABORTED') {
                error(new Error('Request timed out. Please try again.'));
            } else if (e.response) {
                const { status, data } = e.response;
                
                // Handle specific HTTP status codes
                if (status === 400) {
                    const errorMessage = data?.message || 'Invalid doctor ID provided';
                    error(new Error(`Bad Request: ${errorMessage}`));
                } else if (status === 401) {
                    error(new Error('Authentication required. Please login again.'));
                } else if (status === 404) {
                    error(new Error('Interest enabled status not found for this doctor ID.'));
                } else if (status === 500) {
                    const errorMessage = data?.message || 'Internal server error';
                    error(new Error(`Server Error: ${errorMessage}`));
                } else {
                    const errorMessage = data?.message || e.message;
                    error(new Error(`API Error (${status}): ${errorMessage}`));
                }
            } else if (e.request) {
                error(new Error('Unable to connect to the CarePay backend server. Please check your internet connection.'));
            } else {
                error(new Error(e.message || 'Unknown error occurred'));
            }
        });
};

// Get Disbursement Data by Loan ID
export const getDisburseDataByLoanId = (loanId, callback, error) => {
    console.log('Getting disbursement data for loan ID:', loanId);
    
    const headerConfig = {
        headers: {
            'Accept': 'application/json'
        },
        timeout: 30000
    };
    
    loanApi.get(LOAN_APIS.GET_DISBURSE_DATA_BY_LOAN_ID(loanId), headerConfig)
        .then(res => {
            const { status, data, message } = res.data || {};
            const payload = data?.unifiedDisburseData || data?.disburseData || data;
            
            if (payload && typeof payload === 'object') {
                callback({
                    success: true,
                    data: payload,
                    message: message || 'Disbursement data retrieved successfully'
                });
            } else if (status === 404) {
                // Handle 404 case specifically
                callback({
                    success: false,
                    message: message || 'Disbursement data not found'
                });
            } else {
                // Handle other error cases
                error(new Error(message || 'Failed to fetch disbursement data'));
            }
        })
        .catch(e => {
            console.error('Error getting disbursement data by loan ID:', e);
            
            // Handle axios errors
            if (e.code === 'ECONNABORTED') {
                error(new Error('Request timed out. Please try again.'));
            } else if (e.response) {
                const { status, data } = e.response;
                
                // Handle specific HTTP status codes
                if (status === 400) {
                    const errorMessage = data?.message || 'Invalid loan ID provided';
                    error(new Error(`Bad Request: ${errorMessage}`));
                } else if (status === 401) {
                    error(new Error('Authentication required. Please login again.'));
                } else if (status === 404) {
                    error(new Error('Disbursement data not found for this loan ID.'));
                } else if (status === 500) {
                    const errorMessage = data?.message || 'Internal server error';
                    error(new Error(`Server Error: ${errorMessage}`));
                } else {
                    const errorMessage = data?.message || e.message;
                    error(new Error(`API Error (${status}): ${errorMessage}`));
                }
            } else if (e.request) {
                error(new Error('Unable to connect to the backend server. Please check your internet connection.'));
            } else {
                error(new Error(e.message || 'Unknown error occurred'));
            }
        });
};

// Lumi API helpers (scans + credit-ledger)
// clinic filter = doctor_code (e.g. CP2835). Optional basic auth via env.
const getLumiAuthConfig = () => {
    const headerConfig = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        timeout: 30000
    };

    const user = process.env.REACT_APP_LUMI_BASIC_USER;
    const pass = process.env.REACT_APP_LUMI_BASIC_PASSWORD;
    if (user && pass) {
        headerConfig.auth = { username: user, password: pass };
    }

    return headerConfig;
};

// Scans
export const getScans = (params = {}, callback, error) => {
    const url = LOAN_APIS.GET_SCANS(params);

    loanApi.get(url, getLumiAuthConfig())
        .then(res => {
            if (res.data?.results && Array.isArray(res.data.results)) {
                callback({
                    count: res.data.count ?? res.data.results.length,
                    results: res.data.results
                });
            } else if (Array.isArray(res.data)) {
                callback({ count: res.data.length, results: res.data });
            } else {
                error(new Error('Failed to fetch scans'));
            }
        })
        .catch(e => {
            console.error('Scans API call failed:', e);
            error(e);
        });
};

export const formatScan = (scan) => {
    const parseDate = (dateStr) => {
        if (!dateStr) return null;
        try {
            return new Date(dateStr);
        } catch (e) {
            return null;
        }
    };

    const formatDate = (dateStr) => {
        const date = parseDate(dateStr);
        if (!date) return '—';
        return date.toLocaleString('en-GB', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const formatDatePart = (dateStr) => {
        const date = parseDate(dateStr);
        if (!date) return '—';
        return date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };

    const formatTimePart = (dateStr) => {
        const date = parseDate(dateStr);
        if (!date) return '';
        return date.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };

    const phone = scan.patient_phone || '';

    return {
        id: scan.id,
        clinicCode: scan.clinic_code || '—',
        patientId: scan.patient || '',
        patientPhone: phone || '—',
        scanType: scan.scan_type || '—',
        status: scan.status || '—',
        initiatedAt: formatDate(scan.initiated_at),
        startedAt: formatDate(scan.started_at),
        completedAt: formatDate(scan.completed_at),
        datePart: formatDatePart(scan.completed_at || scan.initiated_at),
        timePart: formatTimePart(scan.completed_at || scan.initiated_at),
        failedAt: formatDate(scan.failed_at),
        failureReason: scan.failure_reason || '',
        resultSummary: scan.result_summary || scan.result_json?.summary || '',
        resultScore:
            scan.result_score != null && scan.result_score !== ''
                ? scan.result_score
                : scan.result_json?.score != null
                    ? scan.result_json.score
                    : '',
        resultJson: scan.result_json || null,
        creditsCharged:
            scan.credits_charged != null && scan.credits_charged !== ''
                ? scan.credits_charged
                : 0,
        landingSlug: scan.landing_slug || '—',
        usedDefaultRate: Boolean(scan.used_default_rate),
        ledgerEntry: scan.ledger_entry || null,
        raw: scan
    };
};

// Credit Ledger — clinic = doctor_code (e.g. CP2835). Newest first.
export const getCreditLedger = (params = {}, callback, error) => {
    const url = LOAN_APIS.GET_CREDIT_LEDGER(params);

    loanApi.get(url, getLumiAuthConfig())
        .then(res => {
            // List response
            if (res.data?.results && Array.isArray(res.data.results)) {
                callback({
                    count: res.data.count ?? res.data.results.length,
                    next: res.data.next ?? null,
                    previous: res.data.previous ?? null,
                    results: res.data.results
                });
                return;
            }
            // Single ledger entry by id
            if (res.data?.id && res.data?.transaction_type) {
                callback({
                    count: 1,
                    next: null,
                    previous: null,
                    results: [res.data]
                });
                return;
            }
            if (Array.isArray(res.data)) {
                callback({ count: res.data.length, results: res.data });
                return;
            }
            error(new Error('Failed to fetch credit ledger'));
        })
        .catch(e => {
            console.error('Credit ledger API call failed:', e);
            error(e);
        });
};

export const formatLedgerEntry = (entry) => {
    const createdAt = entry.created_at ? new Date(entry.created_at) : null;
    const type = (entry.transaction_type || '').toLowerCase();
    const credits = Number(entry.credits) || 0;
    const isCreditIn = credits > 0 || ['topup', 'bonus', 'refund'].includes(type);
    const description = entry.description || '';

    const analysisMatch = description.match(/\(([^)]+Analysis)\)/i);
    const packageMatch = description.match(/Package top-up:\s*(.+)$/i);

    const titleMap = {
        topup: 'Credits Added',
        deduction: 'Analysis Deducted',
        refund: 'Credits Refunded',
        adjustment: 'Balance Adjustment',
        bonus: 'Bonus Credits'
    };

    let title = titleMap[type] || (isCreditIn ? 'Credits Added' : 'Credits Deducted');
    let detail = description;

    if (type === 'topup' && packageMatch) {
        detail = packageMatch[1].trim();
    } else if (type === 'deduction' && analysisMatch) {
        detail = analysisMatch[1].trim();
    } else if (!detail && entry.reference) {
        detail = `Ref: ${entry.reference}`;
    }

    const dateLabel = createdAt
        ? createdAt.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        })
        : '—';
    const timeLabel = createdAt
        ? createdAt.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        })
        : '';

    return {
        id: entry.id,
        clinicCode: entry.clinic_code || '—',
        clinic: entry.clinic || '',
        transactionType: type,
        isCreditIn,
        isTopup: type === 'topup',
        isDeduction: type === 'deduction',
        credits,
        balanceAfter: entry.balance_after ?? null,
        reference: entry.reference || '',
        packageId: entry.package || null,
        createdBy: entry.created_by ?? null,
        description,
        title,
        detail,
        dateLabel,
        timeLabel,
        createdAt,
        raw: entry
    };
};

export const summarizeCreditLedger = (entries = []) => {
    // API returns newest first (-created_at); keep that order for display
    const sorted = [...entries].sort((a, b) => {
        const aTime = a.createdAt ? a.createdAt.getTime() : 0;
        const bTime = b.createdAt ? b.createdAt.getTime() : 0;
        return bTime - aTime;
    });

    const creditsLeft = sorted.length > 0 && sorted[0].balanceAfter != null
        ? Number(sorted[0].balanceAfter)
        : 0;

    // Positive credits = in (topup / bonus / refund / +adjustment)
    const totalPurchased = entries.reduce((sum, entry) => {
        const type = entry.transactionType;
        if (type === 'topup' || type === 'bonus') {
            return sum + Math.abs(Number(entry.credits) || 0);
        }
        return sum;
    }, 0);

    // Deductions (and negative adjustments) = utilised
    const utilisedCredits = entries.reduce((sum, entry) => {
        const type = entry.transactionType;
        const amount = Number(entry.credits) || 0;
        if (type === 'deduction') {
            return sum + Math.abs(amount);
        }
        if (type === 'adjustment' && amount < 0) {
            return sum + Math.abs(amount);
        }
        return sum;
    }, 0);

    return {
        creditsLeft,
        totalPurchased,
        utilisedCredits,
        entries: sorted
    };
};

const getBackendAuthConfig = () => ({
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    },
    timeout: 30000
});

// CarePay often returns { status, data, message } where `data` is a JSON string
const parseMaybeJson = (value) => {
    if (typeof value !== 'string') return value;
    const trimmed = value.trim();
    if (!trimmed || (trimmed[0] !== '{' && trimmed[0] !== '[')) return value;
    try {
        return JSON.parse(trimmed);
    } catch (e) {
        return value;
    }
};

const unwrapBackendPayload = (resData) => {
    if (resData == null) return null;
    if (typeof resData === 'string') return parseMaybeJson(resData);
    if (Object.prototype.hasOwnProperty.call(resData, 'data')) {
        return parseMaybeJson(resData.data);
    }
    return resData;
};

const normalizePaymentLink = (rawInput = {}) => {
    const raw = parseMaybeJson(rawInput) || {};

    // List API returns `amount` in paise; create may return amountRupees + amountPaise
    const amountPaise =
        raw.amountPaise ??
        raw.amount_paise ??
        (raw.amountRupees == null && raw.amount_rupees == null && raw.amount != null
            ? Number(raw.amount)
            : null);
    const amountRupeesExplicit = raw.amountRupees ?? raw.amount_rupees ?? null;
    const amountRupees =
        amountRupeesExplicit != null
            ? Number(amountRupeesExplicit)
            : amountPaise != null && Number.isFinite(Number(amountPaise))
                ? Number(amountPaise) / 100
                : null;

    return {
        paymentLinkId: raw.paymentLinkId || raw.payment_link_id || '',
        paymentLinkUrl: raw.paymentLinkUrl || raw.payment_link_url || raw.shortUrl || raw.short_url || '',
        merchantId: raw.merchantId || raw.merchant_id || '',
        clinicCode: raw.clinicCode || raw.clinic_code || '',
        amountRupees: Number.isFinite(amountRupees) ? amountRupees : null,
        amountPaise: amountPaise != null && Number.isFinite(Number(amountPaise))
            ? Number(amountPaise)
            : amountRupees != null && Number.isFinite(amountRupees)
                ? Math.round(amountRupees * 100)
                : null,
        purpose: raw.purpose || '',
        referenceId: raw.referenceId || raw.reference_id || '',
        clientRequestId: raw.clientRequestId || raw.client_request_id || '',
        description: raw.description || '',
        status: (raw.status || '').toLowerCase(),
        reusedExisting: Boolean(raw.reusedExisting ?? raw.reused_existing),
        paymentId: raw.paymentId || raw.payment_id || '',
        creditsPosted: (raw.creditsPosted || raw.credits_posted || 'no').toLowerCase(),
        creditsPostResponse: raw.creditsPostResponse || raw.credits_post_response || '',
        createdAt: raw.addedOn || raw.createdAt || raw.created_at || raw.razorpayCreatedAt || null,
        paidDate: raw.paidDate || raw.paid_date || null,
        raw
    };
};

// Create Razorpay payment link for CREDIT_TOPUP (posts to Lumi ledger after pay + sync)
export const createMerchantPaymentLink = (payload = {}, callback, error) => {
    const url = LOAN_APIS.CREATE_MERCHANT_PAYMENT_LINK();
    loanApi.post(url, payload, getBackendAuthConfig())
        .then((res) => {
            const data = unwrapBackendPayload(res.data);
            if (data?.paymentLinkUrl || data?.paymentLinkId || data?.payment_link_id) {
                callback(normalizePaymentLink(data));
                return;
            }
            error(new Error(res.data?.message || 'Failed to create payment link'));
        })
        .catch((e) => {
            console.error('Create merchant payment link failed:', e);
            error(e);
        });
};

export const getMerchantPaymentLinkDetail = (paymentLinkId, callback, error) => {
    const url = LOAN_APIS.GET_MERCHANT_PAYMENT_LINK_DETAIL(paymentLinkId);
    loanApi.get(url, getBackendAuthConfig())
        .then((res) => {
            const data = unwrapBackendPayload(res.data);
            callback(normalizePaymentLink(data));
        })
        .catch((e) => {
            console.error('Payment link detail failed:', e);
            error(e);
        });
};

export const listMerchantPaymentLinks = (merchantId, callback, error) => {
    const url = LOAN_APIS.LIST_MERCHANT_PAYMENT_LINKS(merchantId);
    loanApi.get(url, getBackendAuthConfig())
        .then((res) => {
            const data = unwrapBackendPayload(res.data);
            const list = Array.isArray(data)
                ? data
                : Array.isArray(data?.results)
                    ? data.results
                    : Array.isArray(data?.links)
                        ? data.links
                        : [];
            callback(list.map(normalizePaymentLink));
        })
        .catch((e) => {
            console.error('List merchant payment links failed:', e);
            error(e);
        });
};

// Poll Razorpay → mark paid once → Lumi top-up once (creditsPosted: no|processing|yes|failed)
export const syncMerchantPaymentLinkStatus = (paymentLinkId, callback, error) => {
    const url = LOAN_APIS.SYNC_MERCHANT_PAYMENT_LINK_STATUS(paymentLinkId);
    loanApi.get(url, getBackendAuthConfig())
        .then((res) => {
            const data = unwrapBackendPayload(res.data);
            callback(normalizePaymentLink(data));
        })
        .catch((e) => {
            console.error('Sync payment link status failed:', e);
            error(e);
        });
};
